import _1 from './img_1.png'
import _2 from './img_2.png'
import _3 from './img_3.png'
import _4 from './img.png'



const resume = [_1, _2, _3, _4]
export default resume
